import { APENFTOrders, APENFTQuery, Network } from "sherry-test-js-1";
let isTest = true;
let contractAdress;
let tronWebfullNodeHost;
let apenftBaseUrl;
let elementSDKAPI;
let apiConfig;

if (window.location.hostname === "nft.btfs.io") {
    contractAdress = "TRC721_TFAngi1UtqKmMC34ZfiVHeivxg9rjTk5tz";
    tronWebfullNodeHost = "https://api.trongrid.io";
    apenftBaseUrl = "https://apenft.io"
    elementSDKAPI = "https://api.apenft.io";
    apiConfig = {
        networkName: Network.Tron,
      };
    isTest = false;
} else {
    contractAdress = "TRC721_TMHy4QNm8vtHbytjGGKpgHMrmjv3QW2dRU";
    tronWebfullNodeHost = "https://api.shasta.trongrid.io";
    apenftBaseUrl = "https://testnet.apenft.io"
    elementSDKAPI = "https://api-testnet.apenft.io";
    apiConfig = {
        networkName:  Network.Shasta,
      };
    isTest = true;
}
export {
    contractAdress,
    tronWebfullNodeHost,
    apenftBaseUrl,
    elementSDKAPI,
    apiConfig,
    isTest,
};